/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useLayoutEffect, useRef } from 'react';
import { mapValues } from 'lodash';
import { CreatorCrmPage } from '@client/new/pages/crm/CrmUsers.page';

export const withLegacyStyles = (Component: any) => (props: any) => {
  useEffect(() => {
    if (!window) return;
    // @ts-ignore
    window.document.querySelector('#application')?.classList?.add('legacy');
    return () => {
      // @ts-ignore
      window?.document
        ?.querySelector('#application')
        ?.classList?.remove('legacy');
    };
  }, []);
  return (
    <div style={{ display: 'contents' }} className="legacy_page_styles">
      <Component {...props} />
    </div>
  );
};

export const withLegacyTweakedStyles = (Component: any) => (props: any) => {
  useEffect(() => {
    if (!window) return;
    // @ts-ignore
    window.document
      .querySelector('#application')
      ?.classList?.add('legacy-tweaked');
    return () => {
      // @ts-ignore
      window?.document
        ?.querySelector('#application')
        ?.classList?.remove('legacy-tweaked');
    };
  }, []);
  return (
    <div style={{ display: 'contents' }} className="legacy_tweaked_page_styles">
      <Component {...props} />
    </div>
  );
};

export const withLegacyBackground = (Component: any) => (props: any) => {
  const ref = useRef<HTMLDivElement | null>(null);

  useLayoutEffect(() => {
    // add classname to first child of ref
    if (!ref.current) return;
    const parentElement = ref.current?.parentElement;
    if (!parentElement) return;
    parentElement.classList.add('bg-primary-superlight');
  }, []);

  return (
    <div ref={ref} style={{ display: 'contents' }}>
      <Component {...props} />
    </div>
  );
};
/**
 * If a component is wrapped in `withLegacyBackground` in `routes`, it'll be
 * called on update, causing mounts and unmounts of the component.
 * It ensures the wrapping is only done once, preventing unnecessary remounts.
 */
export const wrappedWithLegacyBackground = mapValues(
  { CreatorCrmPage },
  withLegacyBackground,
);
